import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { ErrorBoundary } from './ErrorBoundary';
import { AppProviders } from './providers/AppProviders';
import { createAppRouter } from './routeTree';

/** Application root: error boundary → providers → data router. */
export function App() {
  const [router] = useState(() => createAppRouter());
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}
